module.exports = __webpack_public_path__ + "static/media/noAppointments.e2fd80ed.svg";